@file:OptIn(InternalResourceApi::class)

package loco

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/loco/"

@delegate:ResourceContentHash(611_614_048)
public val Res.string.ABOUT_PRODUCT_SCREEN_TITLE_FORMAT: StringResource by lazy {
      StringResource("string:ABOUT_PRODUCT_SCREEN_TITLE_FORMAT", "ABOUT_PRODUCT_SCREEN_TITLE_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 57),
      ))
    }

@delegate:ResourceContentHash(-2_134_914_203)
public val Res.string.BLAND_TODAY_MAIN_CONTROL_SECTION: StringResource by lazy {
      StringResource("string:BLAND_TODAY_MAIN_CONTROL_SECTION", "BLAND_TODAY_MAIN_CONTROL_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68, 56),
      ))
    }

@delegate:ResourceContentHash(1_815_823_376)
public val Res.string.CALI_GREETINGS_1: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_1", "CALI_GREETINGS_1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249, 52),
      ))
    }

@delegate:ResourceContentHash(-1_685_094_130)
public val Res.string.CALI_GREETINGS_10: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_10", "CALI_GREETINGS_10", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125, 61),
      ))
    }

@delegate:ResourceContentHash(-2_122_444_676)
public val Res.string.CALI_GREETINGS_11: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_11", "CALI_GREETINGS_11", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187, 61),
      ))
    }

@delegate:ResourceContentHash(1_398_066_125)
public val Res.string.CALI_GREETINGS_2: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_2", "CALI_GREETINGS_2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 302, 48),
      ))
    }

@delegate:ResourceContentHash(-1_448_910_733)
public val Res.string.CALI_GREETINGS_3: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_3", "CALI_GREETINGS_3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351, 60),
      ))
    }

@delegate:ResourceContentHash(597_694_185)
public val Res.string.CALI_GREETINGS_4: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_4", "CALI_GREETINGS_4", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 412, 52),
      ))
    }

@delegate:ResourceContentHash(-789_757_492)
public val Res.string.CALI_GREETINGS_5: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_5", "CALI_GREETINGS_5", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 465, 48),
      ))
    }

@delegate:ResourceContentHash(-1_693_305_994)
public val Res.string.CALI_GREETINGS_6: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_6", "CALI_GREETINGS_6", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 514, 64),
      ))
    }

@delegate:ResourceContentHash(-2_110_120_739)
public val Res.string.CALI_GREETINGS_7: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_7", "CALI_GREETINGS_7", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 579, 60),
      ))
    }

@delegate:ResourceContentHash(1_095_711_309)
public val Res.string.CALI_GREETINGS_8: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_8", "CALI_GREETINGS_8", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 640, 64),
      ))
    }

@delegate:ResourceContentHash(-265_384_426)
public val Res.string.CALI_GREETINGS_9: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_9", "CALI_GREETINGS_9", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 705, 60),
      ))
    }

@delegate:ResourceContentHash(-1_900_588_825)
public val Res.string.CALI_GREETINGS_USERNAME_FORMAT: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_USERNAME_FORMAT", "CALI_GREETINGS_USERNAME_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 766, 50),
      ))
    }

@delegate:ResourceContentHash(-1_912_982_568)
public val Res.string.CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL: StringResource by lazy {
      StringResource("string:CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL", "CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 817, 61),
      ))
    }

@delegate:ResourceContentHash(2_114_512_017)
public val Res.string.CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT: StringResource by lazy {
      StringResource("string:CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT", "CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 879, 148),
      ))
    }

@delegate:ResourceContentHash(1_928_686_352)
public val Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER: StringResource by lazy {
      StringResource("string:CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER", "CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1028, 76),
      ))
    }

@delegate:ResourceContentHash(-1_224_828_868)
public val Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL: StringResource by lazy {
      StringResource("string:CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL", "CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1105, 88),
      ))
    }

@delegate:ResourceContentHash(-1_818_290_496)
public val Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT: StringResource by lazy {
      StringResource("string:CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT", "CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1194, 123),
      ))
    }

@delegate:ResourceContentHash(654_169_512)
public val Res.string.CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL: StringResource by lazy {
      StringResource("string:CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL", "CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1318, 66),
      ))
    }

@delegate:ResourceContentHash(-526_342_742)
public val Res.string.CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT: StringResource by lazy {
      StringResource("string:CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT", "CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1385, 113),
      ))
    }

@delegate:ResourceContentHash(-619_482_339)
public val Res.string.CONTENT_MEAL_PLAN_PERSONAL_LABEL: StringResource by lazy {
      StringResource("string:CONTENT_MEAL_PLAN_PERSONAL_LABEL", "CONTENT_MEAL_PLAN_PERSONAL_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1499, 72),
      ))
    }

@delegate:ResourceContentHash(728_890_283)
public val Res.string.CONTENT_SHOPPING_LIST_BUTTON: StringResource by lazy {
      StringResource("string:CONTENT_SHOPPING_LIST_BUTTON", "CONTENT_SHOPPING_LIST_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1572, 56),
      ))
    }

@delegate:ResourceContentHash(1_507_453_160)
public val Res.string.DAILY_TASKS_COMPLETED_TASKS_SECTION: StringResource by lazy {
      StringResource("string:DAILY_TASKS_COMPLETED_TASKS_SECTION", "DAILY_TASKS_COMPLETED_TASKS_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1629, 51),
      ))
    }

@delegate:ResourceContentHash(-321_472_009)
public val Res.string.DAILY_TASKS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:DAILY_TASKS_SCREEN_TITLE", "DAILY_TASKS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1681, 60),
      ))
    }

@delegate:ResourceContentHash(-759_213_832)
public val Res.string.DAILY_TASKS_TO_DO_TASKS_SECTION: StringResource by lazy {
      StringResource("string:DAILY_TASKS_TO_DO_TASKS_SECTION", "DAILY_TASKS_TO_DO_TASKS_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1742, 51),
      ))
    }

@delegate:ResourceContentHash(1_938_425_666)
public val Res.string.ERROR_INVALID_CREDENTIALS: StringResource by lazy {
      StringResource("string:ERROR_INVALID_CREDENTIALS", "ERROR_INVALID_CREDENTIALS", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1794, 73),
      ))
    }

@delegate:ResourceContentHash(-1_443_531_834)
public val Res.string.FOOD_HISTORY_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:FOOD_HISTORY_SCREEN_TITLE", "FOOD_HISTORY_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1868, 61),
      ))
    }

@delegate:ResourceContentHash(2_517_491)
public val Res.string.GENERAL_BMI: StringResource by lazy {
      StringResource("string:GENERAL_BMI", "GENERAL_BMI", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1930, 23),
      ))
    }

@delegate:ResourceContentHash(2_701_734)
public val Res.string.GENERAL_CALORIES: StringResource by lazy {
      StringResource("string:GENERAL_CALORIES", "GENERAL_CALORIES", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1998, 28),
      ))
    }

@delegate:ResourceContentHash(-2_008_018_382)
public val Res.string.GENERAL_CALORIES_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_CALORIES_FORMAT", "GENERAL_CALORIES_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1954, 43),
      ))
    }

@delegate:ResourceContentHash(-1_320_945_082)
public val Res.string.GENERAL_CANCEL: StringResource by lazy {
      StringResource("string:GENERAL_CANCEL", "GENERAL_CANCEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2027, 30),
      ))
    }

@delegate:ResourceContentHash(-1_317_195_283)
public val Res.string.GENERAL_CARBO: StringResource by lazy {
      StringResource("string:GENERAL_CARBO", "GENERAL_CARBO", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2058, 29),
      ))
    }

@delegate:ResourceContentHash(2_462_670)
public val Res.string.GENERAL_CM_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_CM_LABEL", "GENERAL_CM_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2088, 28),
      ))
    }

@delegate:ResourceContentHash(-1_438_907_004)
public val Res.string.GENERAL_CONTINUE: StringResource by lazy {
      StringResource("string:GENERAL_CONTINUE", "GENERAL_CONTINUE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2117, 36),
      ))
    }

@delegate:ResourceContentHash(1_982_517_832)
public val Res.string.GENERAL_DETAILS: StringResource by lazy {
      StringResource("string:GENERAL_DETAILS", "GENERAL_DETAILS", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2154, 35),
      ))
    }

@delegate:ResourceContentHash(-251_899_012)
public val Res.string.GENERAL_ERROR_MAX_VALUE: StringResource by lazy {
      StringResource("string:GENERAL_ERROR_MAX_VALUE", "GENERAL_ERROR_MAX_VALUE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2190, 71),
      ))
    }

@delegate:ResourceContentHash(-36_853_601)
public val Res.string.GENERAL_ERROR_MIN_VALUE: StringResource by lazy {
      StringResource("string:GENERAL_ERROR_MIN_VALUE", "GENERAL_ERROR_MIN_VALUE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2262, 71),
      ))
    }

@delegate:ResourceContentHash(2_549_829)
public val Res.string.GENERAL_FAT: StringResource by lazy {
      StringResource("string:GENERAL_FAT", "GENERAL_FAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2334, 23),
      ))
    }

@delegate:ResourceContentHash(-1_972_812_406)
public val Res.string.GENERAL_FIBRE: StringResource by lazy {
      StringResource("string:GENERAL_FIBRE", "GENERAL_FIBRE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2358, 29),
      ))
    }

@delegate:ResourceContentHash(2_551_144)
public val Res.string.GENERAL_FT_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_FT_LABEL", "GENERAL_FT_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2388, 28),
      ))
    }

@delegate:ResourceContentHash(2_789_472)
public val Res.string.GENERAL_FT_UNIT: StringResource by lazy {
      StringResource("string:GENERAL_FT_UNIT", "GENERAL_FT_UNIT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2417, 27),
      ))
    }

@delegate:ResourceContentHash(-799_444_258)
public val Res.string.GENERAL_GOOD_AFTERNOON: StringResource by lazy {
      StringResource("string:GENERAL_GOOD_AFTERNOON", "GENERAL_GOOD_AFTERNOON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2445, 50),
      ))
    }

@delegate:ResourceContentHash(-271_365_401)
public val Res.string.GENERAL_GOOD_EVENING: StringResource by lazy {
      StringResource("string:GENERAL_GOOD_EVENING", "GENERAL_GOOD_EVENING", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2496, 44),
      ))
    }

@delegate:ResourceContentHash(-1_315_908_349)
public val Res.string.GENERAL_GOOD_MORNING: StringResource by lazy {
      StringResource("string:GENERAL_GOOD_MORNING", "GENERAL_GOOD_MORNING", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2541, 44),
      ))
    }

@delegate:ResourceContentHash(2_053_040_823)
public val Res.string.GENERAL_GOOD_NIGHT: StringResource by lazy {
      StringResource("string:GENERAL_GOOD_NIGHT", "GENERAL_GOOD_NIGHT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2586, 42),
      ))
    }

@delegate:ResourceContentHash(2_975_007)
public val Res.string.GENERAL_IN_UNIT: StringResource by lazy {
      StringResource("string:GENERAL_IN_UNIT", "GENERAL_IN_UNIT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2629, 27),
      ))
    }

@delegate:ResourceContentHash(2_523_833)
public val Res.string.GENERAL_KG_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_KG_LABEL", "GENERAL_KG_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2657, 28),
      ))
    }

@delegate:ResourceContentHash(2_572_999)
public val Res.string.GENERAL_LB_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_LB_LABEL", "GENERAL_LB_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2686, 28),
      ))
    }

@delegate:ResourceContentHash(724_307_063)
public val Res.string.GENERAL_LITRES: StringResource by lazy {
      StringResource("string:GENERAL_LITRES", "GENERAL_LITRES", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2715, 30),
      ))
    }

@delegate:ResourceContentHash(3_026_085)
public val Res.string.GENERAL_NOW: StringResource by lazy {
      StringResource("string:GENERAL_NOW", "GENERAL_NOW", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2746, 23),
      ))
    }

@delegate:ResourceContentHash(2_554_120)
public val Res.string.GENERAL_OK: StringResource by lazy {
      StringResource("string:GENERAL_OK", "GENERAL_OK", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2770, 22),
      ))
    }

@delegate:ResourceContentHash(377_512_238)
public val Res.string.GENERAL_OPEN: StringResource by lazy {
      StringResource("string:GENERAL_OPEN", "GENERAL_OPEN", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2793, 28),
      ))
    }

@delegate:ResourceContentHash(2_972_031)
public val Res.string.GENERAL_OZ: StringResource by lazy {
      StringResource("string:GENERAL_OZ", "GENERAL_OZ", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2822, 22),
      ))
    }

@delegate:ResourceContentHash(1_006_446_305)
public val Res.string.GENERAL_PROTEIN: StringResource by lazy {
      StringResource("string:GENERAL_PROTEIN", "GENERAL_PROTEIN", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2845, 35),
      ))
    }

@delegate:ResourceContentHash(-1_746_808_998)
public val Res.string.GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT", "GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2881, 61),
      ))
    }

@delegate:ResourceContentHash(-1_490_956_026)
public val Res.string.GENERAL_RELATIVE_DATE_TODAY: StringResource by lazy {
      StringResource("string:GENERAL_RELATIVE_DATE_TODAY", "GENERAL_RELATIVE_DATE_TODAY", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2943, 43),
      ))
    }

@delegate:ResourceContentHash(897_300_760)
public val Res.string.GENERAL_RELATIVE_DATE_YESTERDAY: StringResource by lazy {
      StringResource("string:GENERAL_RELATIVE_DATE_YESTERDAY", "GENERAL_RELATIVE_DATE_YESTERDAY", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2987, 51),
      ))
    }

@delegate:ResourceContentHash(1_293_511_808)
public val Res.string.GENERAL_SAVE: StringResource by lazy {
      StringResource("string:GENERAL_SAVE", "GENERAL_SAVE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3039, 28),
      ))
    }

@delegate:ResourceContentHash(1_207_930_399)
public val Res.string.GENERAL_STEPS: StringResource by lazy {
      StringResource("string:GENERAL_STEPS", "GENERAL_STEPS", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3068, 29),
      ))
    }

@delegate:ResourceContentHash(-1_925_155_524)
public val Res.string.GENERAL_SYMPTOM_BLOATING: StringResource by lazy {
      StringResource("string:GENERAL_SYMPTOM_BLOATING", "GENERAL_SYMPTOM_BLOATING", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3098, 44),
      ))
    }

@delegate:ResourceContentHash(1_261_633_803)
public val Res.string.GENERAL_SYMPTOM_CONSTIPATION: StringResource by lazy {
      StringResource("string:GENERAL_SYMPTOM_CONSTIPATION", "GENERAL_SYMPTOM_CONSTIPATION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3143, 52),
      ))
    }

@delegate:ResourceContentHash(-1_641_262_680)
public val Res.string.GENERAL_SYMPTOM_EXCESS_GAS: StringResource by lazy {
      StringResource("string:GENERAL_SYMPTOM_EXCESS_GAS", "GENERAL_SYMPTOM_EXCESS_GAS", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3196, 50),
      ))
    }

@delegate:ResourceContentHash(0)
public val Res.string.GENERAL_SYMPTOM_UNKNOWN: StringResource by lazy {
      StringResource("string:GENERAL_SYMPTOM_UNKNOWN", "GENERAL_SYMPTOM_UNKNOWN", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3247, 31),
      ))
    }

@delegate:ResourceContentHash(-120_496_940)
public val Res.string.GENERAL_TODAY: StringResource by lazy {
      StringResource("string:GENERAL_TODAY", "GENERAL_TODAY", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3279, 29),
      ))
    }

@delegate:ResourceContentHash(-562_927_559)
public val Res.string.GENERAL_WEIGHT_GRAM_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_GRAM_FORMAT", "GENERAL_WEIGHT_GRAM_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3309, 42),
      ))
    }

@delegate:ResourceContentHash(-2_000_571_469)
public val Res.string.GENERAL_WEIGHT_KG_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_KG_FORMAT", "GENERAL_WEIGHT_KG_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3352, 44),
      ))
    }

@delegate:ResourceContentHash(-1_999_693_115)
public val Res.string.GENERAL_WEIGHT_LB_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_WEIGHT_LB_FORMAT", "GENERAL_WEIGHT_LB_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3397, 44),
      ))
    }

@delegate:ResourceContentHash(-2_067_923_276)
public val Res.string.HEALTH_LOG_SAVE_BUTTON: StringResource by lazy {
      StringResource("string:HEALTH_LOG_SAVE_BUTTON", "HEALTH_LOG_SAVE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3442, 38),
      ))
    }

@delegate:ResourceContentHash(636_193_769)
public val Res.string.HEALTH_LOG_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:HEALTH_LOG_SCREEN_TITLE", "HEALTH_LOG_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3481, 47),
      ))
    }

@delegate:ResourceContentHash(-668_252_164)
public val Res.string.HEALTH_TOOLS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:HEALTH_TOOLS_SCREEN_TITLE", "HEALTH_TOOLS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3529, 49),
      ))
    }

@delegate:ResourceContentHash(1_346_763_727)
public val Res.string.INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT: StringResource by lazy {
      StringResource("string:INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT", "INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3579, 64),
      ))
    }

@delegate:ResourceContentHash(183_750_309)
public val Res.string.INSIGHTS_FAVORITES_EMPTY_MESSAGE: StringResource by lazy {
      StringResource("string:INSIGHTS_FAVORITES_EMPTY_MESSAGE", "INSIGHTS_FAVORITES_EMPTY_MESSAGE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3644, 168),
      ))
    }

@delegate:ResourceContentHash(681_315_356)
public val Res.string.INSIGHTS_FAVORITES_EMPTY_TITLE: StringResource by lazy {
      StringResource("string:INSIGHTS_FAVORITES_EMPTY_TITLE", "INSIGHTS_FAVORITES_EMPTY_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3813, 70),
      ))
    }

@delegate:ResourceContentHash(-1_519_406_820)
public val Res.string.INSIGHTS_GREETING: StringResource by lazy {
      StringResource("string:INSIGHTS_GREETING", "INSIGHTS_GREETING", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3928, 45),
      ))
    }

@delegate:ResourceContentHash(3_094_314)
public val Res.string.INSIGHTS_GREETING_NAME_FALLBACK: StringResource by lazy {
      StringResource("string:INSIGHTS_GREETING_NAME_FALLBACK", "INSIGHTS_GREETING_NAME_FALLBACK", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3884, 43),
      ))
    }

@delegate:ResourceContentHash(1_987_832_892)
public val Res.string.INSIGHTS_RECENTS_EMPTY_MESSAGE: StringResource by lazy {
      StringResource("string:INSIGHTS_RECENTS_EMPTY_MESSAGE", "INSIGHTS_RECENTS_EMPTY_MESSAGE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3974, 150),
      ))
    }

@delegate:ResourceContentHash(-366_463_752)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES", "INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4125, 64),
      ))
    }

@delegate:ResourceContentHash(1_537_355_486)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS", "INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4190, 58),
      ))
    }

@delegate:ResourceContentHash(264_046_125)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS", "INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4249, 64),
      ))
    }

@delegate:ResourceContentHash(1_788_142_817)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_RECIPES: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_RECIPES", "INSIGHTS_SAVED_CONTENT_HEADER_RECIPES", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4314, 57),
      ))
    }

@delegate:ResourceContentHash(947_518_009)
public val Res.string.INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS: StringResource by lazy {
      StringResource("string:INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS", "INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4372, 58),
      ))
    }

@delegate:ResourceContentHash(2_500_513)
public val Res.string.INSIGHTS_TAB_ALL: StringResource by lazy {
      StringResource("string:INSIGHTS_TAB_ALL", "INSIGHTS_TAB_ALL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4431, 28),
      ))
    }

@delegate:ResourceContentHash(1_886_002_565)
public val Res.string.INSIGHTS_TAB_FAVORITES: StringResource by lazy {
      StringResource("string:INSIGHTS_TAB_FAVORITES", "INSIGHTS_TAB_FAVORITES", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4460, 42),
      ))
    }

@delegate:ResourceContentHash(-1_460_956_398)
public val Res.string.INSIGHTS_TAB_RECENTLY_VIEWED: StringResource by lazy {
      StringResource("string:INSIGHTS_TAB_RECENTLY_VIEWED", "INSIGHTS_TAB_RECENTLY_VIEWED", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4503, 56),
      ))
    }

@delegate:ResourceContentHash(1_521_865_039)
public val Res.string.LEGAL_PRODUCT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:LEGAL_PRODUCT_SCREEN_TITLE", "LEGAL_PRODUCT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4560, 42),
      ))
    }

@delegate:ResourceContentHash(1_871_100_427)
public val Res.string.LIFE_TODAY_ACTIVITY_CARD_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_ACTIVITY_CARD_LABEL", "LIFE_TODAY_ACTIVITY_CARD_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4603, 50),
      ))
    }

@delegate:ResourceContentHash(2_050_005_986)
public val Res.string.LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT: StringResource by lazy {
      StringResource("string:LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT", "LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4654, 68),
      ))
    }

@delegate:ResourceContentHash(-2_006_864_298)
public val Res.string.LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT: StringResource by lazy {
      StringResource("string:LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT", "LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4723, 64),
      ))
    }

@delegate:ResourceContentHash(-1_997_829_519)
public val Res.string.LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT: StringResource by lazy {
      StringResource("string:LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT", "LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4788, 68),
      ))
    }

@delegate:ResourceContentHash(-1_690_218_630)
public val Res.string.LIFE_TODAY_DAILY_TASKS_SECTION: StringResource by lazy {
      StringResource("string:LIFE_TODAY_DAILY_TASKS_SECTION", "LIFE_TODAY_DAILY_TASKS_SECTION", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4857, 54),
      ))
    }

@delegate:ResourceContentHash(351_840_181)
public val Res.string.LIFE_TODAY_LOG_SYMPTOMS_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_LOG_SYMPTOMS_LABEL", "LIFE_TODAY_LOG_SYMPTOMS_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4912, 49),
      ))
    }

@delegate:ResourceContentHash(-2_142_555_969)
public val Res.string.LIFE_TODAY_MEAL_PLAN_CARD_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_MEAL_PLAN_CARD_LABEL", "LIFE_TODAY_MEAL_PLAN_CARD_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4962, 51),
      ))
    }

@delegate:ResourceContentHash(-1_260_485_096)
public val Res.string.LIFE_TODAY_WATER_CARD_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_WATER_CARD_LABEL", "LIFE_TODAY_WATER_CARD_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5014, 43),
      ))
    }

@delegate:ResourceContentHash(-743_348_906)
public val Res.string.LIFE_TODAY_WEIGHT_CARD_LABEL: StringResource by lazy {
      StringResource("string:LIFE_TODAY_WEIGHT_CARD_LABEL", "LIFE_TODAY_WEIGHT_CARD_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5058, 44),
      ))
    }

@delegate:ResourceContentHash(-1_757_122_133)
public val Res.string.LOGIN_CONTACT_US_BUTTON: StringResource by lazy {
      StringResource("string:LOGIN_CONTACT_US_BUTTON", "LOGIN_CONTACT_US_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5103, 47),
      ))
    }

@delegate:ResourceContentHash(-1_713_180_008)
public val Res.string.LOGIN_EMAIL_PLACEHOLDER: StringResource by lazy {
      StringResource("string:LOGIN_EMAIL_PLACEHOLDER", "LOGIN_EMAIL_PLACEHOLDER", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5151, 39),
      ))
    }

@delegate:ResourceContentHash(829_436_744)
public val Res.string.LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT: StringResource by lazy {
      StringResource("string:LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT", "LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5191, 95),
      ))
    }

@delegate:ResourceContentHash(691_855_911)
public val Res.string.LOGIN_LOGIN_BUTTON: StringResource by lazy {
      StringResource("string:LOGIN_LOGIN_BUTTON", "LOGIN_LOGIN_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5287, 34),
      ))
    }

@delegate:ResourceContentHash(-1_252_028_226)
public val Res.string.LOGIN_PASSWORD_PLACEHOLDER: StringResource by lazy {
      StringResource("string:LOGIN_PASSWORD_PLACEHOLDER", "LOGIN_PASSWORD_PLACEHOLDER", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5322, 46),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("ABOUT_PRODUCT_SCREEN_TITLE_FORMAT", Res.string.ABOUT_PRODUCT_SCREEN_TITLE_FORMAT)
  map.put("BLAND_TODAY_MAIN_CONTROL_SECTION", Res.string.BLAND_TODAY_MAIN_CONTROL_SECTION)
  map.put("CALI_GREETINGS_1", Res.string.CALI_GREETINGS_1)
  map.put("CALI_GREETINGS_10", Res.string.CALI_GREETINGS_10)
  map.put("CALI_GREETINGS_11", Res.string.CALI_GREETINGS_11)
  map.put("CALI_GREETINGS_2", Res.string.CALI_GREETINGS_2)
  map.put("CALI_GREETINGS_3", Res.string.CALI_GREETINGS_3)
  map.put("CALI_GREETINGS_4", Res.string.CALI_GREETINGS_4)
  map.put("CALI_GREETINGS_5", Res.string.CALI_GREETINGS_5)
  map.put("CALI_GREETINGS_6", Res.string.CALI_GREETINGS_6)
  map.put("CALI_GREETINGS_7", Res.string.CALI_GREETINGS_7)
  map.put("CALI_GREETINGS_8", Res.string.CALI_GREETINGS_8)
  map.put("CALI_GREETINGS_9", Res.string.CALI_GREETINGS_9)
  map.put("CALI_GREETINGS_USERNAME_FORMAT", Res.string.CALI_GREETINGS_USERNAME_FORMAT)
  map.put("CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL", Res.string.CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL)
  map.put("CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT", Res.string.CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT)
  map.put("CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER", Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER)
  map.put("CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL", Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL)
  map.put("CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT", Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT)
  map.put("CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL", Res.string.CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL)
  map.put("CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT", Res.string.CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT)
  map.put("CONTENT_MEAL_PLAN_PERSONAL_LABEL", Res.string.CONTENT_MEAL_PLAN_PERSONAL_LABEL)
  map.put("CONTENT_SHOPPING_LIST_BUTTON", Res.string.CONTENT_SHOPPING_LIST_BUTTON)
  map.put("DAILY_TASKS_COMPLETED_TASKS_SECTION", Res.string.DAILY_TASKS_COMPLETED_TASKS_SECTION)
  map.put("DAILY_TASKS_SCREEN_TITLE", Res.string.DAILY_TASKS_SCREEN_TITLE)
  map.put("DAILY_TASKS_TO_DO_TASKS_SECTION", Res.string.DAILY_TASKS_TO_DO_TASKS_SECTION)
  map.put("ERROR_INVALID_CREDENTIALS", Res.string.ERROR_INVALID_CREDENTIALS)
  map.put("FOOD_HISTORY_SCREEN_TITLE", Res.string.FOOD_HISTORY_SCREEN_TITLE)
  map.put("GENERAL_BMI", Res.string.GENERAL_BMI)
  map.put("GENERAL_CALORIES", Res.string.GENERAL_CALORIES)
  map.put("GENERAL_CALORIES_FORMAT", Res.string.GENERAL_CALORIES_FORMAT)
  map.put("GENERAL_CANCEL", Res.string.GENERAL_CANCEL)
  map.put("GENERAL_CARBO", Res.string.GENERAL_CARBO)
  map.put("GENERAL_CM_LABEL", Res.string.GENERAL_CM_LABEL)
  map.put("GENERAL_CONTINUE", Res.string.GENERAL_CONTINUE)
  map.put("GENERAL_DETAILS", Res.string.GENERAL_DETAILS)
  map.put("GENERAL_ERROR_MAX_VALUE", Res.string.GENERAL_ERROR_MAX_VALUE)
  map.put("GENERAL_ERROR_MIN_VALUE", Res.string.GENERAL_ERROR_MIN_VALUE)
  map.put("GENERAL_FAT", Res.string.GENERAL_FAT)
  map.put("GENERAL_FIBRE", Res.string.GENERAL_FIBRE)
  map.put("GENERAL_FT_LABEL", Res.string.GENERAL_FT_LABEL)
  map.put("GENERAL_FT_UNIT", Res.string.GENERAL_FT_UNIT)
  map.put("GENERAL_GOOD_AFTERNOON", Res.string.GENERAL_GOOD_AFTERNOON)
  map.put("GENERAL_GOOD_EVENING", Res.string.GENERAL_GOOD_EVENING)
  map.put("GENERAL_GOOD_MORNING", Res.string.GENERAL_GOOD_MORNING)
  map.put("GENERAL_GOOD_NIGHT", Res.string.GENERAL_GOOD_NIGHT)
  map.put("GENERAL_IN_UNIT", Res.string.GENERAL_IN_UNIT)
  map.put("GENERAL_KG_LABEL", Res.string.GENERAL_KG_LABEL)
  map.put("GENERAL_LB_LABEL", Res.string.GENERAL_LB_LABEL)
  map.put("GENERAL_LITRES", Res.string.GENERAL_LITRES)
  map.put("GENERAL_NOW", Res.string.GENERAL_NOW)
  map.put("GENERAL_OK", Res.string.GENERAL_OK)
  map.put("GENERAL_OPEN", Res.string.GENERAL_OPEN)
  map.put("GENERAL_OZ", Res.string.GENERAL_OZ)
  map.put("GENERAL_PROTEIN", Res.string.GENERAL_PROTEIN)
  map.put("GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT", Res.string.GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT)
  map.put("GENERAL_RELATIVE_DATE_TODAY", Res.string.GENERAL_RELATIVE_DATE_TODAY)
  map.put("GENERAL_RELATIVE_DATE_YESTERDAY", Res.string.GENERAL_RELATIVE_DATE_YESTERDAY)
  map.put("GENERAL_SAVE", Res.string.GENERAL_SAVE)
  map.put("GENERAL_STEPS", Res.string.GENERAL_STEPS)
  map.put("GENERAL_SYMPTOM_BLOATING", Res.string.GENERAL_SYMPTOM_BLOATING)
  map.put("GENERAL_SYMPTOM_CONSTIPATION", Res.string.GENERAL_SYMPTOM_CONSTIPATION)
  map.put("GENERAL_SYMPTOM_EXCESS_GAS", Res.string.GENERAL_SYMPTOM_EXCESS_GAS)
  map.put("GENERAL_SYMPTOM_UNKNOWN", Res.string.GENERAL_SYMPTOM_UNKNOWN)
  map.put("GENERAL_TODAY", Res.string.GENERAL_TODAY)
  map.put("GENERAL_WEIGHT_GRAM_FORMAT", Res.string.GENERAL_WEIGHT_GRAM_FORMAT)
  map.put("GENERAL_WEIGHT_KG_FORMAT", Res.string.GENERAL_WEIGHT_KG_FORMAT)
  map.put("GENERAL_WEIGHT_LB_FORMAT", Res.string.GENERAL_WEIGHT_LB_FORMAT)
  map.put("HEALTH_LOG_SAVE_BUTTON", Res.string.HEALTH_LOG_SAVE_BUTTON)
  map.put("HEALTH_LOG_SCREEN_TITLE", Res.string.HEALTH_LOG_SCREEN_TITLE)
  map.put("HEALTH_TOOLS_SCREEN_TITLE", Res.string.HEALTH_TOOLS_SCREEN_TITLE)
  map.put("INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT", Res.string.INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT)
  map.put("INSIGHTS_FAVORITES_EMPTY_MESSAGE", Res.string.INSIGHTS_FAVORITES_EMPTY_MESSAGE)
  map.put("INSIGHTS_FAVORITES_EMPTY_TITLE", Res.string.INSIGHTS_FAVORITES_EMPTY_TITLE)
  map.put("INSIGHTS_GREETING", Res.string.INSIGHTS_GREETING)
  map.put("INSIGHTS_GREETING_NAME_FALLBACK", Res.string.INSIGHTS_GREETING_NAME_FALLBACK)
  map.put("INSIGHTS_RECENTS_EMPTY_MESSAGE", Res.string.INSIGHTS_RECENTS_EMPTY_MESSAGE)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_RECIPES", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_RECIPES)
  map.put("INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS", Res.string.INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS)
  map.put("INSIGHTS_TAB_ALL", Res.string.INSIGHTS_TAB_ALL)
  map.put("INSIGHTS_TAB_FAVORITES", Res.string.INSIGHTS_TAB_FAVORITES)
  map.put("INSIGHTS_TAB_RECENTLY_VIEWED", Res.string.INSIGHTS_TAB_RECENTLY_VIEWED)
  map.put("LEGAL_PRODUCT_SCREEN_TITLE", Res.string.LEGAL_PRODUCT_SCREEN_TITLE)
  map.put("LIFE_TODAY_ACTIVITY_CARD_LABEL", Res.string.LIFE_TODAY_ACTIVITY_CARD_LABEL)
  map.put("LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT", Res.string.LIFE_TODAY_CALORIES_COUNTER_CALORIES_GOAL_FORMAT)
  map.put("LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT", Res.string.LIFE_TODAY_DAILY_TASKS_LOG_FOOD_LABEL_FORMAT)
  map.put("LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT", Res.string.LIFE_TODAY_DAILY_TASKS_READ_INSIGHT_LABEL_FORMAT)
  map.put("LIFE_TODAY_DAILY_TASKS_SECTION", Res.string.LIFE_TODAY_DAILY_TASKS_SECTION)
  map.put("LIFE_TODAY_LOG_SYMPTOMS_LABEL", Res.string.LIFE_TODAY_LOG_SYMPTOMS_LABEL)
  map.put("LIFE_TODAY_MEAL_PLAN_CARD_LABEL", Res.string.LIFE_TODAY_MEAL_PLAN_CARD_LABEL)
  map.put("LIFE_TODAY_WATER_CARD_LABEL", Res.string.LIFE_TODAY_WATER_CARD_LABEL)
  map.put("LIFE_TODAY_WEIGHT_CARD_LABEL", Res.string.LIFE_TODAY_WEIGHT_CARD_LABEL)
  map.put("LOGIN_CONTACT_US_BUTTON", Res.string.LOGIN_CONTACT_US_BUTTON)
  map.put("LOGIN_EMAIL_PLACEHOLDER", Res.string.LOGIN_EMAIL_PLACEHOLDER)
  map.put("LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT", Res.string.LOGIN_FEEDBACK_EMAIL_SUBJECT_FORMAT)
  map.put("LOGIN_LOGIN_BUTTON", Res.string.LOGIN_LOGIN_BUTTON)
  map.put("LOGIN_PASSWORD_PLACEHOLDER", Res.string.LOGIN_PASSWORD_PLACEHOLDER)
}
